import React, { Fragment } from 'react';
import { useQuery } from "react-query";
import { Link } from 'react-router-dom';

import { ButtonsRow, Column, ColumnContainer, Divider, MainButton, SectionTitle, TileSlider, TitleContainer } from "@beacharound/beacharound-ui";
import { getProductImage } from "@beacharound/beacharound-ui-helpers";

import { getProducts } from '../../api/products';
import { getBundleTitle } from '../../helpers/products';

export default function BeachesProductsSlider({ match }) {

    const { beachSlug } = match.params;

    const { data: products } = useQuery(["beaches", beachSlug, "products", "preview"], () =>
        getProducts({ activitySlug: beachSlug, limit: 10, params: { bundleType: "normal" } }),
        {
            refetchOnWindowFocus: false
        }
    )

    if (!products || products.length <= 0 || !Array.isArray(products)) {
        return <Fragment></Fragment>
    }

    return (
        <ColumnContainer noMargin>
            <Column>
                <TitleContainer>
                    <SectionTitle text="Listino" />
                </TitleContainer>
                <ColumnContainer noMargin>
                    <Column>
                        <TileSlider slides={products.sort((a, b) => a.price - b.price).map(product => {
                            // let string = "A partire da";

                            // if (product.bundleType === 'seasonal') {
                            //     string = "Stagionale a"
                            // }

                            const { title, subtitle } = getBundleTitle(product, { main: true });
                            // const price = product.price?.toFixed(2)
                            const priceComparison = product.priceComparison && product.priceComparison?.toFixed(2);
                            // string = `${string} ${priceComparison ? `<strike>${priceComparison} €</strike> ` : ""}${price}€`
                            return {
                                images: product.relatedProducts?.map(prod => getProductImage(prod.reference?.type)),
                                title,
                                text: subtitle,
                                pretitle: product.price > 0 ? undefined : "",
                                highlight: priceComparison ? "In sconto!" : ""
                            }
                        })} />
                    </Column>
                </ColumnContainer>
                <ButtonsRow fill marginBottom>
                    <MainButton
                        border
                        text="Vedi listino completo"
                        component={Link}
                        to={`${match.url}/prezzi-ombrellone-lettino-sdraio`}
                    />
                </ButtonsRow>
                <Divider />
            </Column>
        </ColumnContainer>
    );
}